import React from "react";
export var Scrollable = function (_a) {
    var children = _a.children, className = _a.className, axis = _a.axis;
    return (React.createElement("div", { className: "".concat(className !== null && className !== void 0 ? className : "", " scrollable-").concat(axis) }, children));
};
